import { TagValues } from "@/model/data/Tag";

export class SearchDevicesReqData {
    searchFilter: SearchFilter;

    constructor(searchFilter: SearchFilter) {
        this.searchFilter = new SearchFilter(
            searchFilter.folderIdsWhereSearchIn,
            searchFilter.installationName,
            searchFilter.machinesSerialNumber,
            searchFilter.folderId,
            searchFilter.branchId,
            searchFilter.tag
        );
    }
}

export class SearchFilter {
    folderIdsWhereSearchIn: number[];
    installationName: string;
    machinesSerialNumber: string;
    folderId: number | undefined;
    branchId: number | undefined;
    tag: TagValues;

    constructor(
        folderIdsWhereSearchIn: number[],
        installationName: string,
        machineSerialNumber: string,
        folderId: number | undefined,
        branchId: number | undefined,
        tag: TagValues
    ) {
        this.folderIdsWhereSearchIn = folderIdsWhereSearchIn;
        this.installationName = installationName;
        this.machinesSerialNumber = machineSerialNumber;
        this.folderId = folderId;
        this.branchId = branchId;
        this.tag = tag;
    }
}
